import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Divider, Typography, Tab, Tabs, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../common/breadcrumbs";
import ThemesApiThemeTab from "./themesApiThemeTab";
import ThemesApiLinkingTab from "./themesApiLinkingTab";
import handleNavigate from "../common/customFunctions/handleNavigate";
// import { GetDateTimeStringToday } from "../utils/systemInfo";
const breadcrumbs = [
  { id: 0, name: "Home", href: "./" },
  { id: 1, name: "Themes", href: "themesApi" },
];
const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    backgroundColor: theme.palette.custom.backgroundColor,
    height: "36px",
    minHeight: "36px",
    borderRadius: "3px",
    padding: "8px 16px",
    color: theme.palette.custom.text,
    "&.Mui-selected": {
      color: theme.palette.custom.text,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
      color: theme.palette.primary,
    },
    "&:hover": {
      backgroundColor: theme.palette.custom.buttonHoverColor,
    },
  })
);
const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  width: "fit-content",
  height: "36px",
  backgroundColor: theme.palette.custom.buttonColor,
  color: theme.palette.custom.buttonTextColor,
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
  float: "right",
}));
function ThemesApiPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box
      sx={{
        p: "12px",
        minHeight: "90vh",
        height: "fit-content",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "block", sm: "center" },
          height: { xs: "fit-content", sm: "64px" },
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: { xs: "block", sm: "flex" },
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <Typography
              sx={{
                fontSize: "45px",
                mb: 0,
                color: theme.palette.custom.text,
              }}
              variant="h2"
              gutterBottom
            >
              {t("Themes")}
            </Typography>
          </Box>
          <Box
            sx={{
              float: "right",
              display: "flex",
              gap: "0.5rem",
              width: "100%",
              justifyContent: "end"
            }}
          >
            <StyledButton
              variant="contained"
              onClick={(event) => {
                handleNavigate(event, navigate, "/addEditThemeApi");
                // navigate();
              }}
            >
              {t("AddTheme")}
            </StyledButton>
            <StyledButton
              variant="contained"
              onClick={(event) => {
                handleNavigate(event, navigate, "/addEditThemeLinking");
                // navigate();
              }}
            >
              {t("AddThemeLink")}
            </StyledButton>
          </Box>
        </Box>
      </Box>
      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{
          style: { backgroundColor: theme.palette.custom.borderColor },
        }}
        value={tabValue}
        onChange={handleTabChange}
        textColor="secondary"
      >
        <StyledTab iconPosition="start" label={t("ThemeProfiles")} key={0} />
        <StyledTab
          iconPosition="start"
          label={t("OrganizationLinking")}
          key={1}
        />
      </Tabs>
      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
      {tabValue === 0 && <ThemesApiThemeTab />}
      {tabValue === 1 && <ThemesApiLinkingTab />}
    </Box>
  );
}

export default ThemesApiPage;
